import clsx from 'clsx';
import React from 'react';

import Label from '@/src/components/common/Elements/Label/Label';
import FileSize from '@/src/components/project/Inbox2/components/EntryPanel/Common/InfoPanel/DetailItems/FileSize/FileSize';
import FormattedDateWithUser from '@/src/components/project/Inbox2/components/EntryPanel/Common/InfoPanel/DetailItems/FormattedDateWithUser/FormattedDateWithUser';
import { FileEntry } from '@/src/components/project/Inbox2/types';
import { cn } from '@/src/util/ui';

type FileDetailsProps = {
  fileEntry: FileEntry;
};

const FileDetails = ({ fileEntry }: FileDetailsProps) => {
  const labelClasses = cn('tw-min-w-[90px]', 'tw-mr-[10px]');
  const mainContainerClasses = cn('tw-mb-[12px]');

  return (
    <div className={clsx('tabContents--fileDetails', 'tw-px-[20px]')}>
      <Label
        htmlFor={'p-Created'}
        label={'Created'}
        labelClasses={labelClasses}
        mainContainerClasses={mainContainerClasses}
      >
        <p id={'p-Created'} className={clsx('tw-text-cfo-black')}>
          <FormattedDateWithUser date={fileEntry.createdDate} userName={fileEntry.from} />
        </p>
      </Label>

      <Label
        htmlFor={'p-fileSize'}
        label={'File Size'}
        labelClasses={labelClasses}
        mainContainerClasses={mainContainerClasses}
      >
        <p id={'p-fileSize'} className={clsx('tw-text-cfo-black')}>
          {fileEntry.fileSize ? <FileSize value={fileEntry.fileSize} /> : 'N/A'}
        </p>
      </Label>
    </div>
  );
};

export default FileDetails;
